import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BlogService } from 'src/app/services/blogs/blog.service';

@Component({
    selector: 'app-latest-news',
    templateUrl: './latest-news.component.html',
    styleUrls: ['./latest-news.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LatestNewsComponent implements OnInit {
  blogs!: any[]

  constructor(private getBlog: BlogService,) { }

  ngOnInit(): void {
    console.log(`test`)
    this.getBlog.getBlogList().subscribe((res:any)=> {
      this.blogs = res
      console.log(this.blogs)
    })

  }

}
